import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v32.12.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { S as e } from "./symbols.js";
import { G as l, L as t } from "./utils/map.js";
import { T as s } from "./index.js";

var LabelManager = /*#__PURE__*/function () {
  function LabelManager(e, l) {
    _classCallCheck(this, LabelManager);

    this.layer = e, this.symbol = l || s.symbols.label.text, this._resetTextSymbol(), this.resetLabel();
  }

  _createClass(LabelManager, [{
    key: "_resetTextSymbol",
    value: function _resetTextSymbol() {
      this.labelTextSymbol = e.fromJSON(this.symbol);
    }
  }, {
    key: "clearLabel",
    value: function clearLabel() {
      this.layer.remove(this.label);
    }
  }, {
    key: "moveLabel",
    value: function moveLabel(e) {
      this.label && (this.label.geometry = e);
    }
  }, {
    key: "resetOffset",
    value: function resetOffset(e) {
      if (this._resetTextSymbol(), e) {
        var _l = this.labelTextSymbol.xoffset + e.x,
            _t = this.labelTextSymbol.yoffset + e.y;

        this.labelTextSymbol.xoffset = _l, this.labelTextSymbol.yoffset = _t;
      }
    }
  }, {
    key: "resetLabel",
    value: function resetLabel() {
      this.label = null;
    }
  }, {
    key: "updateLabel",
    value: function updateLabel(e, s) {
      this.clearLabel(), this.labelTextSymbol.text = s, this.label = l.create(e, this.labelTextSymbol), t.addGraphic(this.layer, this.label);
    }
  }]);

  return LabelManager;
}();

export { LabelManager as L };